const PLENARY_CONTEXT_ID_SESSION_KEY = 'plenaryContextId';

const getPersistedContextId = (): string | null => {
  try {
    return sessionStorage.getItem(PLENARY_CONTEXT_ID_SESSION_KEY);
  } catch {
    return null;
  }
};

export const plenaryIdentity = {
  contextId: getPersistedContextId()
};

export const setPlenaryContextId = (id: string | null) => {
  plenaryIdentity.contextId = id;
  if (id) {
    sessionStorage.setItem(PLENARY_CONTEXT_ID_SESSION_KEY, id);
  } else {
    sessionStorage.removeItem(PLENARY_CONTEXT_ID_SESSION_KEY);
  }
};
